/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandy_Lean_Bull_BlowInputs */

const en_sandy_lean_bull_blow = /** @type {(inputs: Sandy_Lean_Bull_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected`)
};

const de_sandy_lean_bull_blow = /** @type {(inputs: Sandy_Lean_Bull_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte löschen`)
};

/**
* | output |
* | --- |
* | "Delete selected" |
*
* @param {Sandy_Lean_Bull_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sandy_lean_bull_blow = /** @type {((inputs?: Sandy_Lean_Bull_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandy_Lean_Bull_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sandy_lean_bull_blow(inputs)
	return de_sandy_lean_bull_blow(inputs)
});